import styled from 'styled-components';

import { PAGES } from '../../constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { useProcessNotificationTokenMutation, TotadminPermission } from 'data/__generated__';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const Notifications = () => {
    const navigate = useNavigate();

    const [processNotificationTickets, { loading: processNotificationTicketsLoading }] =
        useProcessNotificationTokenMutation({
            onCompleted: ({ processNotificationTickets }) => {
                if (processNotificationTickets) {
                    toast.success('Les erreurs ont bien été traitées');
                } else {
                    toast.error('Une erreur est survenue pendant le traitement des notifications');
                }
            },
        });

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.notifications} />
                </HeaderTitle>
            </Header>
            <ButtonsContainer>
                <TotemPrimaryButton
                    onClick={() => navigate('/notifications/organization')}
                    requiredPermissions={[TotadminPermission.NotificationsSend]}
                >
                    Notifier une organisation
                </TotemPrimaryButton>
                <TotemPrimaryButton
                    onClick={() => navigate('/notifications/site')}
                    requiredPermissions={[TotadminPermission.NotificationsSend]}
                >
                    Notifier un site
                </TotemPrimaryButton>
                <TotemPrimaryButton
                    onClick={() => navigate('/notifications/user')}
                    requiredPermissions={[TotadminPermission.NotificationsSend]}
                >
                    Notifier un utilisateur
                </TotemPrimaryButton>
                <TotemPrimaryButton
                    onClick={(event) => {
                        // We're in a form, this will submit
                        event.preventDefault();
                        processNotificationTickets();
                    }}
                    $isSecondaryStyle
                    disabled={processNotificationTicketsLoading}
                    requiredPermissions={[TotadminPermission.NotificationsSend]}
                >
                    Traiter les erreurs de notifications
                </TotemPrimaryButton>
            </ButtonsContainer>
        </Container>
    );
};

const Container = styled.form`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const ButtonsContainer = styled.div`
    margin-top: 30px;
    margin-left: 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 20px;
`;
